// src/mocks/delays.ts
import type { BaseQueryApi } from '@reduxjs/toolkit/query'
import type { RootState } from '@/store'

export const networkDelay = (api: BaseQueryApi): Promise<void> => {
  const state = api.getState() as RootState
  const ms = state.dev?.networkLatencyMs ?? 300
  return new Promise((r) => setTimeout(r, ms))
}

export const infiniteDelay = (): Promise<never> => new Promise(() => {})
